<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Inversores
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="search"
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        disable-sort
        :loading="carregando"
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <div class="py-2 px-2">
              <v-row no-gutters>
                <v-form @submit.prevent="buscaItens()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
                <v-switch
                  hide-details
                  class="ml-5 mt-1"
                  color="success"
                  v-model="searchDesignadosSwtitch"
                  @click="searchDesignados()"
                  label="Não designados"
                ></v-switch>
                <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="distribuidores"
                  label="Distribuidor"
                  append-icon="expand_more"
                  v-model="distribuidor"
                  hide-details=""
                  :loading="loading || loadingDistribuidores"
                  :disabled="loading || loadingDistribuidores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
                <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="integradores"
                  label="Integrador"
                  append-icon="expand_more"
                  v-model="integrador"
                  hide-details=""
                  :loading="loading || loadingIntegradores"
                  :disabled="loading || loadingIntegradores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
              </v-row>
            </div>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item @click="exportPdf()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">assignment</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para PDF</v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.inv_marca="{ item }">
          {{item.inv_marca}}
          <v-chip v-if="!item.inv_status" class="ml-2" small color="primary">Inativo</v-chip>
        </template>
          <template v-slot:item.inv_interface="{ item }">
          {{returnInterface(item.inv_interface)}}
        </template>
        <template v-slot:item.dados="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="openInfo(item)" color="primary" class="mr-2">
                info
              </v-icon>
            </template>
            <span>Dados dos inversores</span>
          </v-tooltip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-switch
                  hide-details
                  color="success"
                  v-model="item.inv_status"
                  @change="handleOpenDialogStatusInverter(item)"
                  style="margin: unset;"
                ></v-switch>
              </template>
            </v-tooltip>
            <!-- <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="opendialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip> -->
          </v-row>
        </template>
      </v-data-table>
    </div>
    <!-- <div class="ui-create">
      <v-btn color="primary" elevation="3" @click="dialogNovo = true" :loading="loading" :disabled="loading">
        <v-icon color="white" x-large>add</v-icon>
      </v-btn>
    </div> -->
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="600px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{inversor.uuid_inv_id ? 'Editar' : 'Novo'}} inversor
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formInversor">
          <!-- <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
              <v-switch
                hide-details
                class="ml-4 mt-0 mb-2"
                color="success"
                v-model="inversor.inv_status"
                :label="inversor.inv_status ? 'Ativo' : 'Inativo'"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="inversor.inv_marca"
                label="Marca*"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="inversor.inv_modelo"
                label="Modelo*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="inversor.inv_potencia"
                label="Potência*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="inversor.inv_serial"
                label="Serial*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0">
              <v-menu
                ref="calendarData"
                v-model="calendarData"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Garantia*"
                    :rules="[rules.required]"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatada"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarData = false
                      inversor.inv_garantia = $root.Formatter.parseDate(dataFormatada)
                      updatePickerModalData = $root.Formatter.parseDate(dataFormatada)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalData"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :loading="salvando"
                  :disabled="salvando"
                  v-model="data"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0">
              <v-autocomplete
                v-model="inversor.uuid_int_id"
                autocomplete="off"
                :items="integradores"
                :loading="salvando || loadingIntegradores"
                :disabled="salvando || loadingIntegradores"
                label="Integrador*"
                :rules="[rules.required]"
                append-icon="expand_more"
                outlined
              ></v-autocomplete>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="inversor.uuid_uss_id"
                :items="status"
                clearable
                clear-icon="close"
                :rules="[rules.required]"
                label="Status*"
                append-icon="expand_more"
                :loading="salvando || loadingStatus"
                :disabled="salvando || loadingStatus"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
             <v-menu
                ref="calendarData"
                v-model="calendarData"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Garantia"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatada"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarData = false
                      inversor.inv_garantia = $root.Formatter.parseDate(dataFormatada)
                      updatePickerModalData = $root.Formatter.parseDate(dataFormatada)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalData"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :loading="salvando"
                  :disabled="salvando"
                  v-model="data"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="inversor.inv_tipo"
                :items="tipos"
                clearable
                clear-icon="close"
                label="Tipo de Alimentação"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="inversor.inv_marca"
                autofocus
                label="Marca"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
               <v-text-field
                v-model="inversor.inv_modelo"
                label="Modelo"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field-percent
                v-model="inversor.inv_potencia"
                label="Potência KW"
                outlined
                v-bind:properties="{
                  readonly: false,
                  disabled: false,
                  outlined: true,
                  disabled: salvando,
                  loading: salvando
                }"
                v-bind:options="{
                  locale: 'pt-BR',
                  length: 4,
                  precision: 2,
                  empty: null,
                }"
              ></v-text-field-percent>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="inversor.inv_serial"
                label="Número Serial"
                outlined
                :rules="[rules.required]"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="inversor.inv_localizacao"
                label="Localização"
                outlined
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0">
              <v-switch
                hide-details
                class="mt-0 ml-3 mb-4"
                color="success"
                v-model="inversor.inv_status"
                :label="inversor.inv_status ? 'Ativo' : 'Inativo'"
              ></v-switch>
            </v-col> -->
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditInversor()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Inversor
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDialogDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Inversor <b class="text-primary">{{inversor ? inversor.inv_marca : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelDialogDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeInversor()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogInfo"
      persistent
      max-width="1000px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="9">
            Dados dos inversores
          </v-col>
          <v-col cols="3" class="text-right">
            <v-icon @click="dialogInfo = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div>
          <v-data-table
            :headers="headersInfo"
            :items="dadosInfo"
            :search="searchInfo"
            multi-sort
            fixed-header
            height="400px"
            class="elevation-1 base_table"
            :footer-props="{
              itemsPerPageOptions: [5,10,15,20,25,50,100],
              showFirstLastPage: true,
              firstIcon: 'skip_previous',
              lastIcon: 'skip_next',
              prevIcon: 'chevron_left',
              nextIcon: 'chevron_right'
            }"
            :header-props="{
              sortIcon: 'north',
            }"
          >
            <template v-slot:top>
              <v-row no-gutters align="center" justify="space-between">
                <div class="py-2 px-2 table_search_area">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="searchInfo"
                    outlined
                    label="Busca"
                  ></v-text-field>
                </div>
                <div>
                  <v-menu
                    bottom
                    center
                    offset-y
                    max-height="400"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Exportar
                        <v-icon>arrow_drop_down</v-icon>
                      </div>
                    </template>
                    <v-list>
                      <v-list-item @click="''">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">receipt_long</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para XLS</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="''">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">assignment</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para TXT</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-row>
            </template>
          </v-data-table>
        </div>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="dialogInfo = false"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogDesignados"
      persistent
      max-width="1000px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="9">
            Inversores não designados
          </v-col>
          <v-col cols="3" class="text-right">
            <v-icon @click="dialogDesignados = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div>
          <v-data-table
            :headers="headersDesignados"
            :items="dadosDesignados"
            :search="searchSesignados"
            multi-sort
            fixed-header
            height="400px"
            class="elevation-1 base_table"
            :footer-props="{
              itemsPerPageOptions: [5,10,15,20,25,50,100],
              showFirstLastPage: true,
              firstIcon: 'skip_previous',
              lastIcon: 'skip_next',
              prevIcon: 'chevron_left',
              nextIcon: 'chevron_right'
            }"
            :header-props="{
              sortIcon: 'north',
            }"
          >
            <template v-slot:top>
              <v-row no-gutters align="center" justify="space-between">
                <div class="py-2 px-2 table_search_area">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="searchSesignados"
                    outlined
                    label="Busca"
                  ></v-text-field>
                </div>
                <div>
                  <v-menu
                    bottom
                    center
                    offset-y
                    max-height="400"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Exportar
                        <v-icon>arrow_drop_down</v-icon>
                      </div>
                    </template>
                    <v-list>
                      <v-list-item @click="''">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">receipt_long</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para XLS</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="''">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">assignment</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para TXT</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-row>
            </template>
          </v-data-table>
        </div>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="dialogDesignados = false"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogChangeStatusInverter"
      persistent
      max-width="400"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Liga/Desliga Inversor
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="handleCloseDialogStatusInverter()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Por favor informe o motivo de ligar/desligar este inversor
        </div>

        <v-form ref="formChangeStatusInverter">
          <v-row align="center" justify="space-between">
            <v-col>
              <v-textarea
                label="Motivo"
                v-model="changeStatusInverterReason"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              >
              </v-textarea>
            </v-col>
          </v-row>
        </v-form>

        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="handleCloseDialogStatusInverter()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="confirmChangeStatusInverter()"
          >
            Confirmar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
import moment from 'moment'
import RelatorioBase from '@components/impressoes/RelatorioBase.vue'
export default {
  data () {
    return {
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      dialogInfo: false,
      dialogDesignados: false,
      dialogChangeStatusInverter: false,
      searchInfo: '',
      changeStatusInverterReason: '',
      statusInverterSelected: null,
      integradores: [],
      loadingIntegradores: false,
      searchSesignados: '',
      searchDesignadosSwtitch: false,
      status: [],
      loadingStatus: false,
      distribuidorAnterior: '',
      total: 0,
      carregando: false,
      options: {},
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      search: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'inv_id'
        },
        { text: 'Status', value: 'status.uss_nome' },
        { text: 'Garantia', value: 'inv_garantia' },
        { text: 'Usina', value: 'usina_inversor.usina.usi_nome' },
        { text: 'Marca', value: 'inv_marca' },
        { text: 'Modelo', value: 'inv_modelo', align: 'center' },
        { text: 'Serial', value: 'inv_serial', align: 'center' },
        { text: 'Interface', value: 'inv_interface', align: 'center' },
        // {
        //   text: 'Dados',
        //   value: 'dados',
        //   align: 'center',
        //   sortable: false,
        //   width: 80
        // },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      headersInfo: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
          width: 100
        },
        { text: 'Data', value: 'data', align: 'center', width: 100 },
        { text: 'Geração acumulada', value: 'acumulada', align: 'center', width: 180 },
        { text: 'Geração diária', value: 'diaria', align: 'center', width: 150 },
        { text: 'Potência total', value: 'potencia', align: 'center', width: 150 },
        { text: 'Frequência', value: 'frequencia', align: 'center', width: 130 },
        { text: 'Temperatura interna', value: 'temperatura', align: 'center', width: 180 },
        { text: 'R voltagem', value: 'rvoltagem', align: 'center', width: 130 },
        { text: 'R corrente', value: 'rcorrente', align: 'center', width: 130 },
        { text: 'S voltagem', value: 'svoltagem', align: 'center', width: 130 },
        { text: 'S corrente', value: 'scorrente', align: 'center', width: 130 },
        { text: 'T voltagem', value: 'tvoltagem', align: 'center', width: 130 },
        { text: 'T corrente', value: 'tcorrente', align: 'center', width: 130 },
        { text: 'pv1 voltagem', value: 'pv1voltagem', align: 'center', width: 150 },
        { text: 'pv1 corrente', value: 'pv1corrente', align: 'center', width: 150 }
      ],
      interfacesSelect: [
        {
          text: 'SolarMaker',
          value: 1
        },
        {
          text: 'Renac',
          value: 2
        },
        {
          text: 'SolarMan',
          value: 3
        }
      ],
      dadosInfo: [],
      tipos: [
        {
          text: 'Monofásico',
          value: 1
        },
        {
          text: 'Bifásico',
          value: 2
        },
        {
          text: 'Trifásico',
          value: 3
        }
      ],
      headersDesignados: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
          width: 100
        },
        { text: 'Status', value: 'status.uss_nome' },
        { text: 'Garantia', value: 'inv_garantia' },
        { text: 'Marca', value: 'inv_marca' },
        { text: 'Modelo', value: 'inv_modelo', align: 'center' },
        { text: 'Interface', value: 'inv_interface', align: 'center' }
      ],
      dadosDesignados: [],
      data: '',
      dataFormatada: '',
      updatePickerModalData: '',
      calendarData: false,
      distribuidor: '',
      distribuidores: [],
      loadingDistribuidores: false,
      integrador: '',
      user: '',
      nivelUsuarioApelido: '',
      inversor: {
        inv_status: true,
        inv_marca: '',
        inv_modelo: '',
        inv_potencia: '',
        inv_tipo: '',
        inv_serial: '',
        inv_garantia: ''
      }
    }
  },
  watch: {
    data () {
      this.dataFormatada = moment(this.data).format('L')
      this.inversor.inv_garantia = this.$root.Formatter.parseDate(this.dataFormatada)
      this.calendarData = false
    },
    options: {
      handler () {
        this.getInversores()
      },
      deep: true
    }
  },
  methods: {
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios', {
        headers: this.someHeader(),
        distribuidor: this.distribuidor,
        integrador: this.integrador,
        disponives: this.searchDesignadosSwtitch,
        busca: this.searchFinal,
        type: 'inversores'
      })
        .then(res => {
          const baseUrl = window.location.origin
          this.downloadXls(baseUrl + '/' + res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    exportPdf () {
      this.$root.Printer.openDialog(this, {
        titulo: 'Inversores', // Título que aparece centralizado na página e como nome do dialog
        component: RelatorioBase, // componente com o layout a ser impresso
        data: this.dados,
        headers: this.someHeader(), // dados para alimentar o componente, por padrão ele chegará como o props data no componente
        css: `` // Classes css que são adicionados na página de impressão
      })
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários') cabecalhos.push(header)
      })
      return cabecalhos
    },
    returnInterface (item) {
      let dados = this.interfacesSelect.filter((ret) => ret.value === item)
      if (dados.length) {
        return dados[0].text
      } else {
        return '-'
      }
    },
    async getStatus () {
      this.loadingStatus = true
      this.loading = true
      await Api.get('usinas-status')
        .then(res => {
          var arrayStat = []
          res.data.map(sta => {
            arrayStat.push({
              'text': sta.uss_nome,
              'value': sta.uuid_uss_id
            })
          })
          this.status = arrayStat
          this.loadingStatus = false
          this.loading = false
        })
        .catch(err => {
          this.loadingStatus = false
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os status!',
            color: 'error'
          })
          console.log(err)
        })
    },
    loadContent () {
      let filters = this.$route.query
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.busca) {
        this.search = filters.busca
        this.searchFinal = filters.busca
      }
      this.loadFunctions()
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }

      let query = Object.assign({},
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.searchFinal ? { busca: this.searchFinal } : ''
      )

      this.$router.replace({name: 'Inversores', query: query}).catch(() => {})
      this.dados = []
      this.distribuidorAnterior = this.distribuidor
      this.getIntegradores(this.distribuidor)
      this.getInversores()
    },
    buscaItens () {
      this.searchFinal = this.search
      this.options.page = 1
      this.applyFilter()
    },
    limparBusca () {
      this.search = null
      this.searchFinal = null
      this.options.page = 1
      this.applyFilter()
    },
    searchDesignados () {
      this.getInversores()
    },
    loadFunctions () {
      this.getInversores()
      this.getIntegradores()
      this.getDistribuidores()
      this.getStatus()
    },
    async getDistribuidores () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores')
        .then(res => {
          var arrayDists = []
          res.data.map(dist => {
            arrayDists.push({
              'text': dist.dis_nome,
              'value': dist.uuid_dis_id
            })
          })
          this.distribuidores = arrayDists
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getInversores () {
      this.carregando = true
      this.dados = []
      this.total = 0
      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      if (page) {
        pagina = page
      }
      if (itemsPerPage) {
        itensPagina = itemsPerPage
      }
      let filtro = '&filtro='
      if (this.searchDesignadosSwtitch) {
        filtro = '&filtro=nao-designados'
      }
      if (this.distribuidor) {
        filtro += '&distribuidor=' + this.distribuidor
      }
      if (this.integrador) {
        filtro += '&integrador=' + this.integrador
      }
      if (this.searchFinal) {
        filtro += '&busca=' + this.searchFinal
      }
      await Api.get(`inversores?page=${pagina}&per_page=${itensPagina}${filtro}`)
        .then(res => {
          let cha = []
          if (res.data.data.length) {
            res.data.data.map(item => {
              item.inv_garantia = item.inv_garantia ? moment(item.inv_garantia).format('DD/MM/YYYY') : ''
            })
            cha = res.data.data
          }
          this.dados = cha
          this.total = res.data.total
          this.carregando = false
        })
        .catch(err => {
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os inversores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegradores (distribuidor = null) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `integradores/distribuidor/${distribuidor}`
      }

      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          this.integradores = arrayInt
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openNovo (item) {
      this.salvando = true
      this.dialogNovo = true
      Api.get('inversores/' + item.uuid_inv_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.inversor = JSON.parse(JSON.stringify(response.data))
          if (response.data.integrador) {
            this.inversor.uuid_int_id = response.data.integrador.uuid_int_id
          }
          if (response.data.status) {
            this.inversor.uuid_uss_id = response.data.status.uuid_uss_id
          }
          if (response.data.inv_garantia) {
            this.data = response.data.inv_garantia
            this.dataFormatada = moment(this.data).format('L')
            this.updatePickerModalData = this.$root.Formatter.parseDate(this.dataFormatada)
          }
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados do inversor!',
            color: 'error'
          })
        })
    },
    saveEditInversor () {
      if (!this.$refs.formInversor.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'inversores/novo'
      if (this.inversor.uuid_inv_id) {
        endpoint = 'inversores/edita'
      }
      Api.post(endpoint, {...this.inversor, inv_status: this.inversor.inv_status ? 1 : 0})
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialog()
          this.getInversores()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    opendialogDelete (item) {
      this.inversor = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelDialogDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    handleOpenDialogStatusInverter (inverter) {
      this.dialogChangeStatusInverter = true

      if (inverter) {
        this.statusInverterSelected = inverter
      }
    },
    handleCloseDialogStatusInverter () {
      this.dialogChangeStatusInverter = false

      this.statusInverterSelected.inv_status = !this.statusInverterSelected.inv_status
    },
    removeInversor () {
      this.salvando = true
      Api.delete(`inversores/remove/${this.inversor.uuid_inv_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getInversores()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover inversor!',
            color: 'error'
          })
        })
    },
    openInfo () {
      this.dialogInfo = true
    },
    openDesignados () {
      this.dialogDesignados = true
    },
    closeDialog () {
      this.inversor = {
        inv_status: true,
        inv_marca: '',
        inv_modelo: '',
        inv_potencia: '',
        inv_serial: '',
        inv_tipo: '',
        inv_garantia: ''
      }
      if (this.$refs.formInversor) {
        this.$refs.formInversor.resetValidation()
      }
      this.dialogNovo = false
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    },
    confirmChangeStatusInverter () {
      if (!this.$refs.formChangeStatusInverter.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }

      const endpoint = `inversores/${this.statusInverterSelected.uuid_inv_id}/change-status`
      const payload = {
        motivo: this.changeStatusInverterReason,
        status: this.statusInverterSelected.inv_status
      }

      this.salvando = true
      Api.patch(endpoint, payload)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.dialogChangeStatusInverter = false
          this.changeStatusInverterReason = null
          this.getInversores()
        })
        .catch((error) => {
          this.salvando = false
          this.changeStatusInverterReason = null
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.loadContent()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.mw_600 {
  max-width: 600px;
}
.mw_status {
  height: 25px!important;
  min-width: 95px;
  justify-content: center;
  padding: 0 5px!important;
}
.big_area {
  max-width: 600px!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/cadastros/Inversores.vue